import BaseObject from './BaseObject';
import Occasion from '@support/Occasion';
import { preProcessDiffMD } from '@support/markdown';
import { capitalize } from '@support/string';

type HighlightType = 'news' | 'bio' | 'link' | 'location' | 'post';

interface Metadata {
  image?: string;
  link?: string;
  title?: string;
}

const typeTextForHighlight = {
  news: 'In the News',
};

const displayPostSource = {
  twitter: 'Tweet',
};

export class HighlightItem extends BaseObject {
  type: HighlightType;
  source: string;
  content: string;
  date: Occasion;
  metadata: Metadata;

  constructor(props: any = {}) {
    super(props);

    this.type = props.item_type || props.type;
    this.source = props.source;
    this.content = props.content;
    this.date = new Occasion(props.item_date || props.date);
    this.metadata = props.metadata || {};

    if (this.source == 'twitter' && this.type != 'post') {
      this.content = preProcessDiffMD(props.content);
    }
  }

  get displayType(): string {
    const text = typeTextForHighlight[this.type];

    if (text) {
      return text;
    } else if (this.type == 'post') {
      return displayPostSource[this.source];
    } else {
      return `${this.type} change`;
    }
  }

  get displayDate(): string {
    const format = this.date.isThisYear ? 'MMM d' : 'MMM d yyyy';
    return this.date.format(format);
  }

  get displaySource(): string | null {
    if (this.source == 'twitter' && this.type != 'post') {
      return 'Via Twitter';
    } else if (this.type == 'news') {
      return `Via ${this.source}`;
    } else {
      return null;
    }
  }

  get analyticsType(): string {
    let analyticsType = this.source;

    if (this.type == 'news') {
      analyticsType = 'news';
    } else if (['bio', 'link'].includes(this.type)) {
      analyticsType = `${this.source} ${this.type}`;
    }

    return capitalize(analyticsType);
  }
}
